// 📁 src/lightversion/LiteDayGate.jsx

import React from "react";
import { useLite } from "./context/LiteContext";

/**
 * ------------------------------------------------------
 * LiteDayGate (SAFE VERSION)
 * ------------------------------------------------------
 * PURPOSE:
 * - Controls WHETHER actions are allowed
 * - NEVER blocks page rendering
 * - LiteDayLayout owns locking + learning UI
 *
 * RULE:
 * - If action is allowed → render children as-is
 * - If not allowed → render children in read-only mode
 * ------------------------------------------------------
 */

const LiteDayGate = ({ allow = [], children }) => {
  const { currentDay } = useLite();

  // If no rules provided → always allow
  if (!allow.length) return children;

  // Authoritative unlock map (7-day journey)
  const DAY_UNLOCKS = {
    1: ["MTP_DISCOVERY", "PERSONAL_REFLECTION"],
    2: ["WHY_IT_MATTERS", "PURPOSE_CLARIFICATION"],
    3: ["SOLUTION_IDEA", "IDEA_SHAPING"],
    4: ["DIRECTION_ALIGNMENT", "WHY_THIS_DIRECTION"],
    5: ["USER_VALIDATION", "MARKET_REALITY"],
    6: ["GUIDED_LEARNING"],
    7: ["REFLECTION", "NEXT_PATH"],
  };

  const todayUnlocks = DAY_UNLOCKS[currentDay] || [];
  const isAllowed = allow.some((key) => todayUnlocks.includes(key));

  /**
   * 🔑 KEY FIX:
   * Always render children.
   * Let child components decide what to disable.
   */
  return React.cloneElement(children, {
    isLocked: !isAllowed,
  });
};

export default LiteDayGate;
